import axios from "axios";
import { expTokenProcessAndGenerate } from "./AuthApis";
import { baseUrl, baseUrl1 } from "../Pages/ApiCommonService";

const get_token = async () => {
  const token = sessionStorage.getItem('token');
  const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
  return Token;
}

export const getSemanticKeyData = async(lobCode: string, questionCode: string) => {
    const token = await get_token();
    try{
        const response = await axios.get(baseUrl1 + `backgroundapi/SemanticService/GetSemanticKey?lobCode=${lobCode}&questionCode=${questionCode}`, {
            headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the user:', error);
        throw error;
    }
}

export const getSemanticValueData = async(lookupKeyId: number) => {
    const token = await get_token();
    try{
        const response = await axios.get(baseUrl1 + `backgroundapi/SemanticService/GetSemanticKeyValues?lookupKeyId=${lookupKeyId}`, {
            headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the user:', error);
        throw error;
    }
}

export const getQuestionCodes = async() => {
    const token = await get_token();
    try{
        const response = await axios.get(baseUrl + "api/master/GetCheckListQuestionMaster", {
            headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the user:', error);
        throw error;
    }
}

export const getTestResult = async(lookupKeyId: number, baseVariance: string, oppositeVariance: string) => {
    const token = await get_token();
    try{
        const response = await axios.get(baseUrl1 + `backgroundapi/SemanticService/semanticMatcher?string1=${baseVariance}&string2=${oppositeVariance}&semanticKeyId=${lookupKeyId}`, {
            headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the test result:', error);
        throw error;
    }
}

export const addSemanticKey = async(lobCode: string, questionCode: string, keyText: string) => {
    const token = await get_token();
    try{
        const response = await axios.post(baseUrl1 + `backgroundapi/SemanticService/AddSemanticKey`, {
            LobCode: lobCode,
            QuestionCode: questionCode,
            KeyText: keyText
        }, {
            headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    }
    catch (error) {
        console.error('Error in adding the semantic key:', error);
        throw error;
    }
}

export const addSemanticValue = async(keyId: number, valueText: string) => {
    const token = await get_token();
    try{
        const response = await axios.post(baseUrl1 + `backgroundapi/SemanticService/AddSemanticValue`, {
            KeyId: keyId,
            ValueText: valueText
        }, {
            headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    }
    catch (error) {
        console.error('Error in adding the semantic value:', error);
        throw error;
    }
}

export const deleteSemanticKey = async(semanticKeyId: number) => {
    const token = await get_token();
    try{
        const response = await axios.delete(baseUrl1 + `backgroundapi/SemanticService/DeleteSemanticKey?semanticKeyId=${semanticKeyId}`, {
            headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    }
    catch (error) {
        console.error('Error in deleting the semantic key:', error);
        throw error;
    }
}

export const deleteSemanticValue = async(semanticValueId: number) => {
    const token = await get_token();
    try{
        const response = await axios.delete(baseUrl1 + `backgroundapi/SemanticService/DeleteSemanticValue?semanticValueId=${semanticValueId}`, {
            headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    }
    catch (error) {
        console.error('Error in deleting the semantic value:', error);
        throw error;
    }
}

export const exportSemanticRecord = async(lobCode: string, questionCode: string) => {
    const token = await get_token();
    try{
        return await axios.get(baseUrl1 + `backgroundapi/SemanticService/ExportSemanticRecord?lobCode=${lobCode}&questionCode=${questionCode}`, {
            headers: { "Authorization": `Bearer ${token}` },
            responseType: "blob"
        });
    } catch (error) {
        console.error('Error in fetching the test result:', error);
        throw error;
    }
}